import axios from 'axios';
import config from './config';

export const defaultLanguageApi = async(token) => {
    const languageType = localStorage.getItem('languageType');
    let locale = 'zh_CN';
    if(languageType === 'en'){
        locale = 'en_US'
    }else if(languageType === 'ina'){
        locale = 'en_ID'
    }else if(languageType === 'ru_RU'){
        locale = 'ru_RU'
    }else if(languageType === 'es_ES'){
        locale = 'es_ES'
    }else if(languageType === 'fr_FR'){
        locale = 'fr_FR'
    }else if(languageType === 'th_TH'){
        locale = 'th_TH'
    }else if(languageType === 'ms_MS'){
        locale = 'ms_MS'
    }else if(languageType === 'pt_PT'){
        locale = 'pt_PT'
    }else if(languageType === 'vi_VI'){
        locale = 'vi_VI'
    }else if(languageType === 'ar_AR'){
        locale = 'ar_AR'
    }
    // const locale = languageType === 'en' ? 'en_US' : 'zh_CN'
    await axios
        .put(`${config.API_HOST}/iam/hzero/v1/users/default-language?language=${locale}`,{}, {
            headers: {
                Authorization: "Bearer " + token,
            }
          })
} 

/**
 * sso跳转
 */
export const hrefSSO = () =>{
    const menuCode = getQueryVariable('menuCode');
    const routeStr = getQueryVariable('routeStr');
    if (routeStr) {
        sessionStorage.setItem('routeStr', routeStr);
    }
    if (menuCode) {
        sessionStorage.setItem('menuCode', menuCode);
        // const host = `${window.location.protocol}//${window.location.hostname}`
        window.location.href = `${config.SSO_HOST}/oauth2.0/authorize?response_type=code&client_id=itms02&redirect_uri=${config.API_HOST}/oauth/sso/auth&scope=default&state=${config.DOMAIN_NAME}`;
    } 
}

export const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return (false);
}